import { ReactNode, Suspense } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx'

import CircularProgress from '@mui/material/CircularProgress'
import VegaErrorBoundary from './VegaErrorBoundary/VegaErrorBoundary';

const useStyles = makeStyles({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
})

type SuspensefulProps<ChildProps> = {
  component: React.ComponentType<ChildProps>
  fallback?: ReactNode
  errorMessage?: string
  loaderClassName?: string | null,
  children?: ReactNode
}

export default function Suspenseful<ChildProps>({
  component,
  fallback = null,
  errorMessage = "Error loading resource",
  loaderClassName = null,
  children,
  ...props
}: SuspensefulProps<ChildProps> & ChildProps) {
  const classes = useStyles()
  const ChildComponent = component as React.ComponentType<Omit<ChildProps, keyof SuspensefulProps<ChildProps>>> // It would be better if we could restrict ChildProps to disallow keys of SuspensefulProps, but that doesn't seem possible

  return (
    <VegaErrorBoundary defaultErrorMessage={errorMessage}>
      <Suspense fallback={fallback || (
        <div className={clsx(classes.loader, loaderClassName)}>
          <CircularProgress/>
        </div>
      )}>
        <ChildComponent {...props}>
          {children}
        </ChildComponent>
      </Suspense>
    </VegaErrorBoundary>
  )
}
